<template>
    <v-layout>
        <app-sidebar>
            <router-link :to="{ name: ROUTES.HOME }">
                <app-link icon="mdi-arrow-left">Back to your Cases</app-link>
            </router-link>
        </app-sidebar>

        <app-main-view>
            <app-main-card>
                <div class="text-secondary-text text-heading-h3">Formus Case Plans</div>
                <div class="text-subtitle-1 text-secondary">
                    Formus Report and User Generated report in one place
                </div>
            </app-main-card>

            <PlanCard
                v-if="store.state.automatedPlan"
                :project="store.state.project"
                :plan="store.state.automatedPlan"
            />
            <PlanCard
                v-if="store.state.manualPlan"
                :project="store.state.project"
                :plan="store.state.manualPlan"
            />
        </app-main-view>
    </v-layout>
</template>

<script setup lang="ts">
    import { ROUTES } from '@/router';
    import { usePlansStore } from '@/planView/store/store';
    import PlanCard from '@/planView/PlanCard.vue';
    import { onBeforeUnmount } from 'vue';
    import { useRoute } from 'vue-router';
    import { verify } from '@/lib/verify';
    import { useSpinopelvic } from '@/spinopelvic/store/store';

    const route = useRoute();
    const caseIdParam = verify(route.params.id, 'case id is required');
    const caseId = Number(caseIdParam);
    const store = usePlansStore();
    await store.load(caseId);

    await useSpinopelvic().load(caseId);

    onBeforeUnmount(() => {
        store.stopSync();
    });
</script>
